import { call, put, takeLatest } from 'redux-saga/effects';

import * as faqActions from './faqActions.js';
import { updateFaqApiCall } from './faqAPI.js';

function* updateFaqSaga({ payload }) {
  try {
    const { data } = yield call(updateFaqApiCall, payload);
    yield put(faqActions.faqUpdateStore(data));
  } catch (error) {
    yield put(faqActions.faqUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* faqWatcher() {
  yield takeLatest(faqActions.faqUpdateRequest.type, updateFaqSaga);
}
